import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { Box } from '@mui/material';

var FocalPointImage = function FocalPointImage(_ref) {
  var _image$file$details3, _image$file$details4;

  var backgroundImage = _ref.backgroundImage,
      children = _ref.children,
      focalPoint = _ref.focalPoint,
      image = _ref.image,
      style = _ref.style;

  var calculatePosition = function calculatePosition(x, y, width, height) {
    return "".concat(x / width * 100, "% ").concat(y / height * 100, "%");
  };

  if (!backgroundImage) {
    var _image$description, _image$file$details, _image$file$details2;

    return React.createElement(Box, {
      sx: {
        overflow: 'hidden',
        width: 'inherit',
        height: 'inherit'
      }
    }, React.createElement("img", {
      src: image.file.url,
      alt: (_image$description = image.description) !== null && _image$description !== void 0 ? _image$description : '',
      style: _objectSpread(_objectSpread({}, style), {}, {
        overflow: 'hidden',
        minWidth: '100%',
        minHeight: '100%',
        height: '100%',
        width: '100%',
        objectFit: 'cover',
        objectPosition: focalPoint ? calculatePosition(focalPoint.focalPoint.x, focalPoint.focalPoint.y, (_image$file$details = image.file.details) === null || _image$file$details === void 0 ? void 0 : _image$file$details.image.width, (_image$file$details2 = image.file.details) === null || _image$file$details2 === void 0 ? void 0 : _image$file$details2.image.height) : 'center center'
      })
    }));
  }

  return React.createElement(Box, {
    sx: _objectSpread(_objectSpread({}, style), {}, {
      backgroundImage: "url(".concat(image.file.url, ")"),
      backgroundPosition: focalPoint ? calculatePosition(focalPoint.focalPoint.x, focalPoint.focalPoint.y, (_image$file$details3 = image.file.details) === null || _image$file$details3 === void 0 ? void 0 : _image$file$details3.image.width, (_image$file$details4 = image.file.details) === null || _image$file$details4 === void 0 ? void 0 : _image$file$details4.image.height) : 'center center',
      display: 'block',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      height: '100%',
      width: '100%',
      overflow: 'hidden'
    })
  }, children);
};

export default FocalPointImage;